import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconCloudUploadSvg } from './IconCloudUploadSvg';

export const IconCloudUpload: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconCloudUploadSvg} {...iconProps} />;
};
